<nav class="top-nav" aria-label="Primary">
  <div class="top-nav-inner">
    @for (g of navGroups; track g.label) {
      @if (g.kind === "link") {
        <a
          class="top-nav-link"
          [routerLink]="g.href"
          routerLinkActive="top-nav-link--active"
          [routerLinkActiveOptions]="{ exact: g.href === '/' }"
          ariaCurrentWhenActive="page"
        >
          {{ g.label }}
        </a>
      } @else {
        <div class="top-nav-group">
          <button
            type="button"
            class="top-nav-trigger"
            [attr.aria-expanded]="openGroup() === g.label"
            [attr.aria-controls]="panelId(g)"
            (click)="toggle(g.label)"
          >
            {{ g.label }}
            <span class="top-nav-caret" aria-hidden="true">▾</span>
          </button>
          <div
            class="top-nav-panel"
            grooveSurface
            variant="bordered"
            tone="raised"
            [elevation]="4"
            [class.top-nav-panel--end]="isLast(g)"
            [id]="panelId(g)"
            hidden
          >
            @if (g.kind === "panel") {
              <div class="tn-grid">
                @for (section of g.sections; track section.label) {
                  <div class="tn-section">
                    <p class="groove-type-eyebrow">{{ section.label }}</p>
                    <ul class="tn-list">
                      @for (l of section.links; track l.href) {
                        <li>
                          <a
                            class="groove-text-link groove-ring tn-link-shell"
                            [class.top-nav-link-primary]="l.primary"
                            [routerLink]="l.href"
                            routerLinkActive
                            ariaCurrentWhenActive="page"
                            (click)="close()"
                          >
                            {{ l.label }}
                          </a>
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>
            } @else {
              <ul class="tn-list">
                @for (l of g.links; track l.href) {
                  <li>
                    <a
                      class="groove-text-link groove-ring tn-link-shell"
                      [class.top-nav-link-primary]="l.primary"
                      [routerLink]="l.href"
                      routerLinkActive
                      ariaCurrentWhenActive="page"
                      (click)="close()"
                    >
                      {{ l.label }}
                    </a>
                  </li>
                }
              </ul>
            }
          </div>
        </div>
      }
    }
  </div>
</nav>
